// Bootstrap entry — the browser-side boot script loaded by
// `wrapper.html`. Today this is a thin wrapper over `bootWrapper()`
// in `wrapper.ts`; the two files are separated because the full
// bootstrap design () inlines this entry into the
// wrapper HTML at build time, while `wrapper.ts` hosts the reusable
// logic.

import { bootWrapper, type WrapperConfig } from "./wrapper.js";

markBootPhase("bootstrap_module");

// The parent domain is injected by the edge at serve time via the
// `<meta name="p2claw-parent-domain">` tag. The `p2claw.com`
// fallback lets the module load standalone during development;
// production always sets the meta.
function detectParentDomain(): string {
  const meta = document.querySelector<HTMLMetaElement>(
    'meta[name="p2claw-parent-domain"]',
  );
  return meta?.content ?? "p2claw.com";
}

export async function main(): Promise<void> {
  markBootPhase("bootstrap_main");
  const config: WrapperConfig = { parentDomain: detectParentDomain() };
  await bootWrapper(config);
}

// When loaded as a module in the browser, self-start. Tests import
// `main` directly and call it.
if (typeof window !== "undefined" && typeof document !== "undefined") {
  void main();
}

function markBootPhase(phase: string): void {
  if (typeof window === "undefined") return;
  window.__p2clawMarkBootTiming?.(phase);
}
